import { render } from "./ShipmentTrackingView.vue?vue&type=template&id=210f4bf0"
import script from "./ShipmentTrackingView.vue?vue&type=script&lang=ts"
export * from "./ShipmentTrackingView.vue?vue&type=script&lang=ts"
script.render = render

export default script